// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimeOption_wrapper__1Abi3","toggle":"TimeOption_toggle__9Z4Rs","error":"TimeOption_error__3prTM","details":"TimeOption_details__2Oi0j"};